var __TEMP__ = require('./_baseFlatten.js');var baseFlatten = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseIteratee.js');var baseIteratee = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseRest.js');var baseRest = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseUniq.js');var baseUniq = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArrayLikeObject.js');var isArrayLikeObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./last.js');var last = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = unionBy;
